var _ellipse, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOntwerpIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 277,
    height: 254,
    viewBox: "0 0 277 254",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.7,
    cx: 138.5,
    cy: 239.245,
    rx: 138.5,
    ry: 14.5,
    fill: "#EAF2F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.396 16.3678L101.606 6.15812C103.212 4.55211 105.85 4.62858 107.533 6.31108L179.306 78.0847C180.377 79.1554 180.683 80.6849 180.148 81.985C177.318 88.5621 169.402 108.828 172.691 120.721C179.497 135.672 196.858 137.928 205.5 142.631C214.142 147.335 229.284 160.718 233.184 180.717C234.79 192.341 229.016 198.001 229.016 198.001C229.016 198.001 223.051 204.119 211.121 202.819C190.701 199.415 177.318 184.235 172.767 175.44C168.217 166.645 166.343 148.864 151.163 142.325C139.003 139.305 117.933 148.023 111.089 151.12C109.75 151.732 108.144 151.426 107.112 150.394L35.2619 78.5818C33.5794 76.8993 33.5794 74.1462 35.2619 72.4637L69.3706 38.3549L72.0855 35.64L81.7981 45.3526",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.396 16.3678L101.606 6.15812C103.212 4.5521 105.85 4.62858 107.533 6.31108L179.306 78.0847C180.377 79.1554 180.683 80.6849 180.148 81.985C177.318 88.5621 169.402 108.828 172.691 120.721C179.497 135.672 196.858 137.928 205.5 142.631C214.142 147.335 229.284 160.718 233.184 180.717C234.79 192.341 229.016 198.001 229.016 198.001C229.016 198.001 223.051 204.119 211.121 202.819C190.701 199.415 177.318 184.235 172.767 175.44C168.217 166.645 166.343 148.864 151.163 142.325C139.003 139.305 117.933 148.023 111.089 151.12C109.75 151.732 108.144 151.426 107.112 150.394L35.2619 78.5818C33.5794 76.8993 33.5794 74.1462 35.2619 72.4637L69.3706 38.3549L72.0855 35.64L81.7981 45.3526",
    stroke: "#324A6D",
    strokeWidth: 9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0625 99.1557C58.548 100.609 73.7669 113.075 78.8144 105.733C83.8619 98.391 70.899 83.975 70.899 83.975C70.899 83.975 61.0717 70.018 68.4135 63.2498C75.7553 56.4816 89.4829 67.1501 89.4829 67.1501C89.4829 67.1501 102.14 79.4247 106.767 74.9125C111.394 70.4004 105.084 59.2348 105.084 59.2348C105.084 59.2348 96.9012 47.6102 103.211 41.1097C109.52 34.6092 120.915 42.1421 120.915 42.1421C120.915 42.1421 130.169 48.0691 133.113 45.3924C136.057 42.7157 127.339 26.3114 127.339 26.3114",
    stroke: "#F7A941",
    strokeWidth: 9,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M148.715 73.4595L161.716 60.4966",
    stroke: "#324A6D",
    strokeWidth: 9,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4473 132.766L133.727 88.4859",
    stroke: "#324A6D",
    strokeWidth: 9,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M215.631 179.571C215.631 176.297 212.978 173.644 209.704 173.644C206.431 173.644 203.777 176.297 203.777 179.571C203.777 182.844 206.431 185.498 209.704 185.498C212.978 185.498 215.631 182.844 215.631 179.571Z",
    fill: "#324A6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOntwerpIcon);
export default __webpack_public_path__ + "static/media/ontwerp_icon.80a0ec6637440436e73558a7c811feaa.svg";
export { ForwardRef as ReactComponent };